<template>
  <div class="content">
    <transition
      name="form-box"
      @before-enter="collapseBeforeEnter"
      @enter="collapseEnter"
      @after-enter="collapseAfterEnter"
      @before-leave="collapseBeforeLeave"
      @leave="collapseLeave"
      @after-leave="collapseAfterLeave"
    >
      <div v-show="formShow" class="form-content" :style="answerType && answerType === 'true' ? 'height:530px' : ''">
        <p ref="titleRef" class="title">Your moving plan</p>
        <i-form ref="formRef" :model="formData" label-position="top" :label-width="446" class="form">
          <div class="form-item-group">
            <i-form-item style="margin-left: 0" prop="quantity">
              <template #label>
                <div class="form-label">
                  <div>How many packages?</div>
                  <a
                    href="https://support.movingkite.com/hc/en-us/articles/4404704275611"
                    target="_blank"
                    class="label-text-right"
                    >Packing Guidelines
                  </a>
                </div>
              </template>
              <i-input
                ref="quantityInputRef"
                v-model.number="formData.quantity"
                autofocus
                placeholder="Package quantity"
                style="width: 446px"
                onkeypress="return(/[0-9]|[\.\b]/.test(String.fromCharCode(event.keyCode)))"
              ></i-input>
            </i-form-item>
            <i-form-item prop="weight">
              <template #label>
                <div class="form-label">
                  <span>Total weight? (LB)</span>
                  <img
                    src="../../assets/imgs/package-limits.png"
                    style="width: 113px; height: 26px; cursor: pointer"
                    @click="openLimitDialog"
                  />
                </div>
              </template>
              <i-input
                v-model="formData.weight"
                placeholder="Total weight"
                style="width: 446px"
                onkeypress="return(/[0-9]|[\.\b]/.test(String.fromCharCode(event.keyCode)))"
              ></i-input>
            </i-form-item>
          </div>
          <div class="form-item-group">
            <i-form-item>
              <template #label>
                <span>How to ship to storage warehouse?</span>
              </template>

              <div class="card-car-content" :class="{ active: pickup === true }" @click="doClickPickup">
                <div class="car-left">
                  <img src="../../assets/imgs/home-form-car.png" />
                  <div>
                    <p class="car-title">FedEx Pick up</p>
                    <div class="car-right">
                      <label>${{ PICKUP_PRICE }}</label>
                      <span>/ times</span>
                    </div>
                  </div>
                </div>
                <a
                  href="https://support.movingkite.com/hc/en-us/articles/4404707626779"
                  target="_blank"
                  class="car-desc"
                >
                  Learn more about FedEx pick up
                </a>
              </div>
            </i-form-item>
            <i-form-item>
              <template #label>
                <span></span>
              </template>
              <div class="card-car-content" :class="{ active: pickup === false }" @click="doClickDropOff">
                <div class="car-left">
                  <img src="../../assets/imgs/home-form-house.png" />
                  <div>
                    <p class="car-title">Drop off</p>
                    <div class="car-right">
                      <label>Free</label>
                    </div>
                  </div>
                </div>
                <a href="https://local.fedex.com/en-us" target="_blank" class="car-desc">
                  Find FedEx locations nearby
                </a>
              </div>
            </i-form-item>
          </div>
          <i-form-item
            label="Destination confirmed?"
            prop="zipcode"
            :style="errorMessageShow ? 'margin-bottom: 0' : ''"
          >
            <i-radio-group v-model="answerType" style="margin-bottom: 15px" @on-change="radioValueChange">
              <i-radio label="true" style="margin-right: 100px">Yeah, sure</i-radio>
              <i-radio label="false">Not yet</i-radio>
            </i-radio-group>
            <br />
            <input
              v-if="answerType && answerType === 'true'"
              v-model="formData.zipcode"
              class="input"
              placeholder="Destination zipcode"
              :style="{
                width: '446px',
                border: errorMessageShow && answerType === 'true' ? '1px solid red' : '',
                'border-radius': '4px',
              }"
              @blur="checkValue"
            />
          </i-form-item>
          <p v-show="errorMessageShow && answerType === 'true'" class="error-massage">invalid</p>
        </i-form>

        <i-button
          :disabled="disableNextBtn"
          :class="disableNextBtn ? 'disable-btn btn' : 'btn'"
          :style="disableNextBtn ? 'cursor: not-allowed' : ''"
          :loading="disableRateBtn"
          @click="goNextStep"
        >
          Calculate my rate
        </i-button>
      </div>
    </transition>

    <i-dialog v-model="modal" title="Package limits" :footer-hide="true">
      <div v-for="item in limitList" :key="item.title" class="package-limit-card">
        <div>
          <img :src="item.image" :alt="item.title" style="width: 60px" />
        </div>
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div v-for="(content, index) in item.content" :key="index">
              {{ content }}
            </div>
          </div>
        </div>
      </div>
    </i-dialog>

    <i-dialog v-model="limitModal" title="Package limits" ok-text="Continue" @on-ok="doSureNextStep">
      <div class="limit-package-content">
        <div class="content">
          We recommend that individual packages do not exceed 50 lbs in weight. If they exceed this limit, additional
          handling surcharge will be applied.
        </div>
        <div class="click" @click="openLimitDialog">Learn more about package limits ></div>
      </div>
    </i-dialog>

    <!--第二步 地图-->
    <transition
      name="map-box"
      @before-enter="collapseBeforeEnter"
      @enter="collapseEnter"
      @after-enter="collapseAfterEnter"
      @before-leave="collapseBeforeLeave"
      @leave="collapseLeave"
      @after-leave="collapseAfterLeave"
    >
      <div>
        <i-alert
          v-if="formShow && secondShow && searchError"
          type="error"
          show-icon
          style="width: 1000px; margin: 15px auto"
        >
          Error
          <template #desc>
            {{ searchError }}
            <span
              v-if="searchErrorCode === 'kite.front.estimate.weight-max'"
              class="limit-package-color"
              @click="openLimitDialog"
            >
              Learn more about package limits >
            </span>
          </template>
        </i-alert>
        <div v-show="formShow && secondShow && !searchError" class="price-content">
          <div class="title-box">
            <p class="title-text">Select your storage warehouse</p>
            <p class="title-desc">
              The rate below is estimated based on your shipping ZIP and packages info.
            </p>
          </div>

          <div class="map-container">
            <div id="mapDiv" class="map">
              <div v-show="mapLoading" class="loader"></div>
              <div id="map"></div>
            </div>
            <div class="fee-box">
              <div
                v-for="(item, index) in calculateList"
                :key="index"
                style="margin-bottom: 15px; position: relative"
                @click="choseCard(item)"
              >
                <img
                  v-show="item.isChose"
                  src="../../assets/imgs/check-mark.png"
                  style="position: absolute; height: 31px"
                />
                <div
                  :class="{
                    'dropdown-card': true,
                    'dropdown-card-close': !item.isChose,
                    'dropdown-card-disable': !item.enable,
                  }"
                >
                  <div class="dropdown-card-left">
                    <img :style="item.enable ? {} : { filter: 'grayscale(1)' }" src="../../assets/imgs/warehouse.png" />
                    <div>
                      <div style="display: flex; flex-direction: row; align-items: center">
                        <p class="left-title">{{ item.houseName }}</p>
                        <i-tag v-if="Number(item.usageRate) > 95" color="red">No space left</i-tag>
                        <i-progress
                          v-else
                          :percent="Number(item.usageRate)"
                          :stroke-width="15"
                          :stroke-color="Number(item.usageRate) > 90 ? 'red' : 'green'"
                          class="progress"
                        >
                          <span :style="{ color: Number(item.usageRate) > 90 ? 'red' : 'green' }"
                            >{{ Number(item.remainingRate) }}% Remaining</span
                          >
                        </i-progress>
                      </div>
                      <div style="margin-top: 8px">
                        <i-tag v-show="item.tags.includes('CHEAPER')" color="#37C3BA">Cheaper shipping</i-tag>
                        <i-tag v-show="item.tags.includes('FASTER')" color="#37C3BA">Faster delivery</i-tag>
                        <i-tag v-show="item.tags.includes('CLOSER')" color="#37C3BA">Closer to destination</i-tag>
                      </div>
                    </div>
                  </div>

                  <div class="dropdown-card-right">
                    <p>
                      <span class="right-title">${{ item.totalCost }}</span>
                      <br />
                      <span class="right-desc">Shipping fee</span>
                    </p>
                    <img :src="item.dropdownIcon ? openIcon : closeIcon" @click.stop="changCard(item)" />
                  </div>
                </div>

                <transition name="dropdown">
                  <div v-if="item.dropdownIcon" class="dropdown-item-box">
                    <dropdown-item
                      v-for="(it, index) in item.dropdownList"
                      :key="index"
                      :title="it.title"
                      :img="it.img"
                      :desc="it.desc"
                      :days="it.days"
                      :price="it.price"
                      :origin-price="it.originPrice"
                      :class="index === item.dropdownList.length - 1 ? 'without-border' : ''"
                    ></dropdown-item>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <i-button class="btn" @click="creatOrder"> Continue to create order </i-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import config from '../../views/home/config';
import jsLoader from '../../utils/jsLoader';
import DropdownItem from './DropdownItem';
import openIcon from '../../assets/imgs/expendIcon.png';
import closeIcon from '../../assets/imgs/arrowIcon.png';
import { mapActions, mapState } from 'vuex';
import wavehouseIcon from '../../assets/imgs/calculate-wavehouse.png';
import rmIcon from '../../assets/imgs/rm.png';
import locationIcon from '../../assets/imgs/calculate-location.png';
import svgPaths from '../../views/calculate/path.json';
import limitPackage from '../../assets/imgs/limit-package.png';
import limitWeight from '../../assets/imgs/limit-weight.png';
import limitDimension from '../../assets/imgs/limit-dimension.png';
import imgPriceSendShipping from '../../assets/imgs/price-send-shipping.png';
import imgPriceStorage from '../../assets/imgs/price-storage.png';
import imgPriceReturnShipping from '../../assets/imgs/price-return-shipping.png';

export default {
  name: 'PriceForm',
  components: {
    DropdownItem,
  },
  props: ['change'],
  data() {
    return {
      modal: false,
      limitModal: false,
      pickup: null,
      // zipcodeInput: '',
      formShow: false,
      formData: {
        quantity: '',
        weight: '',
        isConfirm: '',
        zipcode: '',
      },
      formRules: {
        // quantity: [{ required: true, message: 'The quantity cannot be empty', trigger: 'blur' }],
        // weight: [{ required: true, message: 'The weight cannot be empty', trigger: 'blur' }]
      },
      answerType: '',
      inputCardContent: config.planCards,
      disableRateBtn: false,
      errorMessageShow: false,
      newSearch: false,
      limitList: [
        {
          image: limitPackage,
          title: 'Packaging',
          content: [
            '• We strongly recommend using cardboard boxes for packaging.',
            '• Luggage can be shipped, but as it is considered an irregularly shaped package.Additional handling surcharge will be applied.',
          ],
        },
        {
          image: limitWeight,
          title: 'Weight',
          content: [
            '• We recommend that individual packages do not exceed 50 lbs in weight.If they exceed this limit, additional handling surcharge will be applied.',
            '• Packages exceeding 150 lbs cannot be transported.',
          ],
        },
        {
          image: limitDimension,
          title: 'Dimension',
          content: [
            'Recommended dimensions: Length + Width + Height ≤ 60 inches, and the longest side ≤ 45 inches. If exceeded, additional handling surcharge will be applied.',
          ],
        },
      ],



      //地图部分
      curHouse: null,
      houseCheaper: '',
      secondShow: false,
      mapLoading: false,
      searchError: false,
      mapLoaded: false,
      searchErrorCode: '',
      searchErrorTitle: 'ERROR',
      dropdownIcon: true,
      openIcon: openIcon,
      closeIcon: closeIcon,
      PICKUP_PRICE: '-.--',
      calculate: {},
      calculateList: [],
      dropdownList: [
        {
          title: 'Pick up',
          price: '',
        },
        {
          title: 'Send shipping',
          desc: 'Shipping to our warehouse by FedEx',
          days: '',
          price: '',
        },
        {
          title: 'Storage',
          img: require('../../assets/imgs/money.png'),
        },
        {
          title: 'Return shipping',
          days: '',
          desc: 'Shipping to destination by FedEx',
          price: '',
        },
      ],

      //动画效果
      oldPaddingTop: '',
      oldPaddingBottom: '',
      oldOverflow: '',
    };
  },
  created() {
    this.$maps = {};
  },
  computed: {
    ...mapState('calculate', ['warehouse']),
    ...mapState('home', ['zipcode']),
    zipcodeInput() {
      return this.zipcode ? this.zipcode : '';
    },
    validateZipcode() {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      return zipreg.test(this.formData.zipcode);
    },
    disableNextBtn() {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      if (
        this.formData.quantity &&
        this.formData.weight &&
        this.answerType === 'false' &&
        typeof this.pickup !== 'object'
      ) {
        return false;
      } else if (
        this.formData.quantity &&
        this.formData.weight &&
        this.answerType === 'true' &&
        this.formData.zipcode &&
        typeof this.pickup !== 'object' &&
        zipreg.test(this.formData.zipcode)
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this._codeMaker = {};
    this._recommandedMaker = null;
    this._navagationPolyline = [];
    this._cartMaker = null;
    this._startMaker = null;
    this._stopMaker = null;
    this._initMaker = false;
    //修改仓库，之前选择的code
    this._houseId = '';
    this.$nextTick(() => {
      this.loadGoolemapJs();
    });
    this.initPickUp();
    this.$bus.$on('headerZipcodeChange', zipcode => {
      if (zipcode !== this.$store.state.home.zipcode) {
        this.secondShow = false;
        this.formShow = false;
        this.searchError = false;
      }
    });
    this.$bus.$on('headerZipcodeInput', () => {
      this.getFocus();
    });
    this.checkCache();
  },
  methods: {
    ...mapActions('calculate', ['search', 'getWareHouse']),
    ...mapActions('send', ['getPickUpPrice', 'getReturnPrice']),
    openLimitDialog() {
      if (this.limitModal) {
        this.limitModal = false;
      }
      this.modal = true;
    },
    checkCache() {
      if (this.change) {
        let cacheDataObj = this.$store.state.home.formComponentData;
        this.formShow = cacheDataObj.formShow;
        this.formData = Object.assign(cacheDataObj.formData);
        this.pickup = cacheDataObj.pickup;
        this.PICKUP_PRICE = cacheDataObj.PICKUP_PRICE;
        this.answerType = cacheDataObj.answerType;
        this.secondShow = cacheDataObj.secondShow;
        // this.calculateList = cacheDataObj.calculateList;
        cacheDataObj.calculateList.forEach(item => {
          this.calculateList.push(item);
        });
        // let calculate = this.calculateList.filter(it => it.isChose)[0];
        // this.testAddMark();

        this.searchCalculate(cacheDataObj.calculateList);
      }
    },
    continueForm() {
      this.$nextTick(() => {
        this.formShow = true;
        let cacheDataObj = this.$store.state.home.formComponentData;
        this.formData = Object.assign(cacheDataObj.formData);
        this.pickup = cacheDataObj.pickup;
        this.answerType = cacheDataObj.answerType;
        this.PICKUP_PRICE = cacheDataObj.PICKUP_PRICE;
      });
    },
    radioValueChange() {
      if (this.answerType !== 'true') {
        this.formData.zipcode = '';
        this.errorMessageShow = false;
      }
    },
    checkValue() {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      if (!this.formData.zipcode || zipreg.test(this.formData.zipcode)) {
        this.errorMessageShow = false;
      } else {
        this.errorMessageShow = true;
      }
    },
    changeValueCheckValue() {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      setTimeout(() => {
        if (!this.formData.zipcode || zipreg.test(this.formData.zipcode)) {
          this.errorMessageShow = false;
        } else {
          this.errorMessageShow = true;
        }
      }, 500);
    },
    getFocus() {
      this.$nextTick(() => {
        this.$refs.quantityInputRef.focus({ cursor: 'start' });
      });
    },
    initPickUp() {
      this.getPickUpPrice()
        .then(res => {
          if (res.success) {
            this.PICKUP_PRICE = res.data;
            this.dropdownList.forEach(item => {
              if (item.title === 'Pick up') {
                item.price = this.PICKUP_PRICE;
              }
            });
          } else {
            setTimeout(() => {
              this.initPickUp();
            }, 1500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initPickUp();
          }, 1500);
        });
    },
    doClickPickup() {
      this.pickup = true;
    },
    doClickDropOff() {
      this.pickup = false;
    },
    doSureNextStep() {
      this.limitModal = false;
      this.disableRateBtn = true;
      this.newSearch = !!this.change;
      this.hideMaker();
      if (this.warehouse.length === 0) {
        this.initWaveHouse(() => {
          this.searchCalculate();
        });
      } else {
        this.searchCalculate();
      }
    },
    goNextStep() {
      const average = +(+this.formData.weight / +this.formData.quantity).toFixed(1);
      if (average > 50 && average < 150) {
        this.limitModal = true;
      } else {
        this.doSureNextStep();
      }
    },
    hideMaker() {
      this.warehouse.forEach(({ houseId }) => {
        this._codeMaker[houseId] && this._codeMaker[houseId].setOpacity(0);
      });
      if (this._recommandedMaker) {
        this._recommandedMaker.setMap(null);
      }
    },
    setCalculate(calculate = {}) {
      this.calculate = calculate;
    },
    checkWaveHouse() {
      let warehouse = this.warehouse,
        _kiteHouse = this._kiteHouse;
      if (this.mapLoaded) {
        if (!this._initMaker) {
          this.addWaveHouseMaker();
        }
      }
      warehouse.forEach(house => {
        let { houseId, lat, lng } = house;
        let _maker = this._codeMaker[houseId];
        if (_kiteHouse[houseId] && _kiteHouse[houseId].enable) {
          _maker && _maker.setOpacity(1);
          if (houseId === this._bestHouse) {
            this.curHouse = house;
            if (this.mapLoaded) {
              this.addRecommandedHouseMaker(lat, lng);
            }
          }
        } else {
          _maker && _maker.setOpacity(0);
        }
      });
    },
    searchHouse({ houseId }) {
      this.calculateList.forEach(it => {
        if (it.houseId !== houseId) {
          this.$set(it, 'isChose', false);
        } else {
          this.$set(it, 'isChose', true);
        }
      });
      let warehouse = this.warehouse;
      if (this.calculate['houseId'] !== houseId) {
        let calculate = this._kiteHouse[houseId];
        if (calculate) {
          this.setCalculate(calculate);
          this.curHouse = warehouse.find(house => house.houseId === houseId);
          let cpoint = new this.$maps.LatLng(this.curHouse.lat, this.curHouse.lng);
          this._map.setCenter(cpoint);
          this.addNavagation();
        }
      }
    },
    addNavagation() {
      if (this.zipcodeInput) {
        let point = null;
        this.geoZipCode(this.zipcodeInput)
          .then(r => {
            point = r;
            if (this._startMaker) {
              this._startMaker.setMap(null);
            }
            this._startMaker = this.addMaker(point);
            return this.geoZipCode(this.formData.zipcode);
          })
          .then(rpoint => {
            this.cleanNavagation();
            var bounds = new this.$maps.LatLngBounds();
            let apoint = new this.$maps.LatLng(this.curHouse.lat, this.curHouse.lng);
            let routes = [point, apoint];
            if (rpoint) {
              routes.push(rpoint);
            }
            routes.forEach(route => {
              bounds.extend(route);
            });
            if (this._cartMaker) {
              this._cartMaker.setMap(null);
              this._cartMaker = null;
            }
            this._map.fitBounds(bounds);
            if (this._stopMaker) {
              this._stopMaker.setMap(null);
            }
            if (rpoint) {
              this._stopMaker = this.addMaker(rpoint);
            }
            this.addPolyLine(routes);
          });
      }
    },
    geoZipCode(zipcode) {
      return new Promise(resolve => {
        this._geocoder.geocode({ address: zipcode }, function (results, status) {
          if (status === 'OK') {
            let point = results[0].geometry.location;
            resolve(point);
          } else {
            resolve(null);
          }
        });
      });
    },
    cleanNavagation() {
      this._navagationPolyline.forEach(it => it.setMap(null));
      this._navagationPolyline.splice(0);
    },
    addPolyLine(points) {
      const polyLineArr = [];

      //添加第一段
      polyLineArr[0] = this.conPolyLine(points[0], points[1]);

      //添加第二段
      if (points.length === 3) {
        polyLineArr[1] = this.conPolyLine(points[1], points[2]);
      }

      this._navagationPolyline.push(...polyLineArr);
      this.startHuocheAnimate(polyLineArr);
    },
    conPolyLine(pointA, pointB) {
      const lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: 2,
      };
      const lineSymbolCar = {
        path: pointA.lng() > pointB.lng() ? svgPaths.left : svgPaths.right,
        scale: 1,
        fillColor: '#6E6DEF',
        fillOpacity: 0, //默认不显示图标，由动画控制是否显示
        rotation: 0,
        fixedRotation: true,
      };
      return new this.$maps.Polyline({
        path: [pointA, pointB],
        geodesic: false,
        strokeColor: '#FF7070',
        strokeOpacity: 0,
        strokeWeight: 2,
        strokeStyle: 'dashed',
        icons: [
          { icon: lineSymbol, offset: '0', repeat: '20px' },
          { icon: lineSymbolCar, offset: '100%' },
        ],
        map: this._map,
      });
    },
    /**
     * 给货车添加动画
     * 基于官方示例 https://developers.google.cn/maps/documentation/javascript/symbols?hl=zh-cn#animate
     *
     * 如果按照官方示例使用一条polyLine，当遇到左右折角的路线（如： < ），卡车在第二段会变成头朝下前进
     * 此问题在对称图形上不会出现
     * 所以需要将线路分为两段（或多段），每段使用其对应方向的卡车Symbol
     * 所以polyLineArr接收一个Polyline数组
     * 每个Polyline包含虚线线段和一个隐藏的卡车Symbol
     * 此方法循环每个Polyline(通过index = (index + 1) % polyLineArr.length控制)
     * 当第一段Polyline跑完后隐藏第一段的卡车并显示第二段的卡车
     * @param polyLineArr
     */
    startHuocheAnimate(polyLineArr) {
      let count = 200;
      /**
       * 官方示例中没有定义stepper，默认为count + 1，即每20ms前进1%
       * 当两段线长度不同时，stepper==1会导致卡车在两段线上的速度不同（因为时间相同：每20ms前进1%）
       * 为了让卡车在每段线上的速度相同，为每一段分别使用不同的步进stepper
       * 通过方法calcStepperRate计算
       */
      let stepperRate = this.calcStepperRate(polyLineArr);
      let stepper = stepperRate.lastItem;
      let index = polyLineArr.lastIndex;
      let flightPath = polyLineArr[index];
      window.setInterval(() => {
        count = count + stepper;
        if (count > 200 && polyLineArr.length > 1) {
          //如果一段跑完(count > 200)，则切换下一段
          const icons1 = flightPath.get('icons');
          icons1[1].icon.fillOpacity = 0; //使当前的透明
          flightPath.set('icons', icons1); //应用，否则不生效
          index = (index + 1) % polyLineArr.length; //切换下一段
          flightPath = polyLineArr[index];
          stepper = stepperRate[index];
        }
        count = count % 200;
        const icons = flightPath.get('icons');
        icons[1].offset = count / 2 + '%';
        icons[1].icon.fillOpacity = 1; //切换后的不透明
        flightPath.set('icons', icons);
      }, 20);
    },
    /**
     * 为了让卡车在每段线上的速度相同，为每一段分别计算不同的步进stepper
     * 卡车在sum长度上每次行进1%的长度所对应到每一段上行进的百分比
     * 如 d0=60, d1=40, sum=100时，卡车每行进1%，就要在d0上前进1.66%，则rateArr[0]=1.66
     */
    twoPointDistance(p1, p2) {
      return Math.sqrt(Math.pow(p1.lat() - p2.lat(), 2) + Math.pow(p1.lng() - p2.lng(), 2));
    },
    calcStepperRate(polyLineArr) {
      if (polyLineArr.length === 1) return [1];
      const distanceArr = [];
      let sum = 0;
      for (let polyLine of polyLineArr) {
        //计算每条线段的距离
        distanceArr.push(this.twoPointDistance(polyLine.getPath().getAt(0), polyLine.getPath().getAt(1)));
        sum += distanceArr.lastItem;
      }
      const rateArr = [];
      for (let dis of distanceArr) {
        rateArr.push(((sum * 0.01) / dis) * 100); // 计算每一段的步进百分比
      }
      return rateArr;
    },
    addMaker(location, label = '') {
      return new this.$maps.Marker({
        position: location,
        map: this._map,
        icon: {
          url: locationIcon,
          scaledSize: {
            width: 33,
            height: 40,
          },
        },
        label: label,
      });
    },
    addWaveHouseMaker() {
      let warehouse = this.warehouse;
      let map = this._map;
      this._initMaker = true;
      var bounds = new this.$maps.LatLngBounds();
      warehouse.forEach(house => {
        let point = new this.$maps.LatLng(house.lat, house.lng);
        let maker = new this.$maps.Marker({
          position: point,
          icon: {
            url: wavehouseIcon,
            scaledSize: {
              width: 27,
              height: 26,
            },
          },
          opacity: 0.2,
        });
        maker.addListener('click', () => {
          this.searchHouse(house);
        });
        maker.setMap(map);
        if (!this._codeMaker) {
          this._codeMaker = {};
        }
        this._codeMaker[house.houseId] = maker;
        bounds.extend(point);
      });
      this._map.setCenter(bounds.getCenter());
    },
    addRecommandedHouseMaker(lat, lng) {
      let location = new this.$maps.LatLng(lat, lng);
      this._recommandedMaker = new this.$maps.Marker({
        position: location,
        icon: {
          url: rmIcon,
          scaledSize: {
            width: 125,
            height: 53,
          },
          anchor: {
            y: 80,
            x: 64,
          },
        },
        map: this._map,
      });
      this._recommandedMaker.addListener('click', () => {
        this.searchHouse({
          code: this._bestHouse,
        });
      });
    },

    searchCalculate(list) {
      this.mapLoading = true;
      this.search({
        zipcode: this.zipcodeInput,
        weight: this.formData.weight,
        rzipcode: this.answerType === 'true' ? this.formData.zipcode : '',
        count: this.formData.quantity,
        pickup: this.pickup,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            let data = res.data;
            this.houseCheaper = data.bestHouse;
            if (!this.change || this.newSearch) {
              this._bestHouse = data.bestHouse;
              this._kiteHouse = data.kiteHouse;

              let notFindWarehouse = false; //当新增仓库时，本地缓存仓库有可能失效，需要先检查本地是否有结果中的仓库
              for (let houseKey in data.kiteHouse) {
                const house = data.kiteHouse[houseKey];
                if (!this.warehouse.find(houseItem => houseItem.houseId === house.houseId)) {
                  notFindWarehouse = true;
                  break;
                }
              }
              if (notFindWarehouse) {
                //如果在缓存中找不到仓库，则重新获取仓库信息
                this.initWaveHouse(() => {
                  this.editData(data);
                });
                return;
              } else {
                this.editData(data);
              }
              let calculate = this._kiteHouse[this._bestHouse];
              this._houseId = calculate.houseId;
              this.setCalculate(calculate);
            } else {
              const listMap = list.reduce((result, item) => {
                result[item.houseId] = item;
                return result;
              }, {});
              this._kiteHouse = listMap;
              let calculate = list.filter(it => it.isChose)[0];
              this._bestHouse = calculate.houseId;
              this._houseId = calculate.houseId;
              this.setCalculate(calculate);
            }
            this.checkWaveHouse();
            if (this.mapLoaded) {
              if (this._houseId) {
                this.searchHouse({ houseId: this._houseId });
              }
              this.addNavagation();
            } else {
              this.$Message.error('loaded google map error.');
            }
            this.searchError = false;
            this.mapLoading = false;
            this.searchErrorCode = '';
          } else {
            this.showPop = true;
            if (res.message === "We don't have enough time to handle your package") {
              this.searchErrorTitle = 'The receipt date is too early! ';
            } else {
              this.searchErrorTitle = 'ERROR';
            }
            this.searchError = res.message;
            this.searchErrorCode = res.code;
          }
        })
        .catch(() => {
          this.init = false;
          this.loading = false;
        })
        .finally(() => {
          this.mapLoading = false;
          this.secondShow = true;
          this.disableRateBtn = false;
          this.newSearch = false;
          if (!this.change) {
            this.$emit('getPriceSuccess', this.answerType);
          }
        });
    },

    editData(data) {
      let dataList = [];
      for (let houseKey in data.kiteHouse) {
        const house = data.kiteHouse[houseKey];
        house.dropdownIcon = house.tags.includes('RECOMMEND');
        house.isChose = house.enable && house.tags.includes('RECOMMEND');
        let list = [
          {
            title: 'Pick up',
            price: '',
          },
          {
            title: 'Send shipping',
            desc: 'Shipping to our warehouse by FedEx',
            days: '',
            price: '',
          },
          {
            title: 'Storage',
            img: require('../../assets/imgs/money.png'),
          },
          {
            title: 'Return shipping',
            days: '',
            desc: 'Shipping to destination by FedEx',
            price: '',
          },
        ];
        house.dropdownList = list;
        house.houseName = this.warehouse.find(houseItem => houseItem.houseId === house.houseId).name;
        house.dropdownList.forEach((item, index) => {
          if (item.title === 'Send shipping') {
            item.price = house.sendCost;
            item.days = house.sendDays;
            item.originPrice = house.sendCostFedex;
          } else if (item.title === 'Return shipping') {
            item.price = house.backCost;
            item.days = house.backDays;
            item.originPrice = house.backCostFedex;
          } else if (item.title === 'Pick up') {
            item.price = house.pickupCost;
          }
        });
        dataList.push(house);
      }
      dataList.sort((a, b) => {
        return a.dropdownIcon === b.dropdownIcon ? 0 : a.dropdownIcon ? -1 : 1;
      });
      this.calculateList = dataList;
    },
    loadGoolemapJs() {
      this.mapLoading = true;
      jsLoader(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyBZhHEG1ZINGM7scAC6fBpHP3CgVyh-jd0&libraries=places&v=weekly',
        'google',
      )
        .then(() => {
          this.mapLoaded = true;
          this.$maps = window.google.maps;
          this.initMap();
        })
        .catch(error => {
          //TODO 是否提示加载错误？
          console.log('error', error);
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    initMap() {
      var dom = document.getElementById('map');
      const map = new this.$maps.Map(dom, {
        zoom: 5,
        mapTypeId: 'roadmap',
        disableDefaultUI: true,
        styles: [
          {
            featureType: 'poi',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      });
      map.setCenter({ lat: 37.2755928, lng: -104.6569351 });

      this._map = map;
      this._geocoder = new this.$maps.Geocoder();
    },
    initWaveHouse(cb) {
      this.getWareHouse()
        .then(res => {
          if (res.success) {
            cb && cb();
          } else {
            setTimeout(() => {
              this.initWaveHouse(cb);
            }, 1500);
          }
        })
        .catch(e => {
          setTimeout(() => {
            this.initWaveHouse(cb);
          }, 1500);
        });
    },
    changCard(item) {
      // this.dropdownIcon = !this.dropdownIcon;
      this.$set(item, 'dropdownIcon', !item.dropdownIcon);
    },
    changeWaveHouse(house) {
      this.searchHouse(house);
    },
    choseCard(item) {
      if (!item.enable) return;
      this.$set(item, 'isChose', true);
      this.calculateList.forEach(it => {
        if (it.houseId !== item.houseId) {
          this.$set(it, 'isChose', false);
        }
      });
      this.changeWaveHouse(item);
    },

    //展开动画效果
    collapseBeforeEnter(el) {
      // console.log('11, collapseBeforeEnter');
      this.oldPaddingBottom = el.style.paddingBottom;
      this.oldPaddingTop = el.style.paddingTop;
      // 过渡效果开始前设置元素的maxHeight为0，让元素maxHeight有一个初始值
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
      el.style.maxHeight = '0';
    },
    collapseEnter(el, done) {
      // console.log('22, collapseEnter');
      //
      this.oldOverflow = el.style.overflow;
      let elHeight = el.scrollHeight;
      // 过渡效果进入后将元素的maxHeight设置为元素本身的高度，将元素maxHeight设置为auto不会有过渡效果
      if (elHeight > 0) {
        el.style.maxHeight = elHeight + 'px';
      } else {
        el.style.maxHeight = '0';
      }
      el.style.paddingTop = this.oldPaddingTop;
      el.style.paddingBottom = this.oldPaddingBottom;

      el.style.overflow = 'hidden';
      // done();
      let onTransitionDone = function () {
        done();
        // console.log('enter onTransitionDone');
        el.removeEventListener('transitionend', onTransitionDone, false);
        el.removeEventListener('transitioncancel', onTransitionDone, false);
      };
      // 绑定元素的transition完成事件，在transition完成后立即完成vue的过度动效
      el.addEventListener('transitionend', onTransitionDone, false);
      el.addEventListener('transitioncancel', onTransitionDone, false);
    },
    collapseAfterEnter(el) {
      // console.log('33, collapseAfterEnter');
      // 过渡效果完成后恢复元素的maxHeight
      el.style.maxHeight = '';
      el.style.overflow = this.oldOverflow;
    },

    collapseBeforeLeave(el) {
      // console.log('44, collapseBeforeLeave', el.scrollHeight);

      this.oldPaddingBottom = el.style.paddingBottom;
      this.oldPaddingTop = el.style.paddingTop;
      this.oldOverflow = el.style.overflow;

      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.overflow = 'hidden';
    },
    collapseLeave(el, done) {
      // console.log('55, collapseLeave', el.scrollHeight);

      if (el.scrollHeight !== 0) {
        el.style.maxHeight = '0';
        el.style.paddingBottom = '0';
        el.style.paddingTop = '0';
      }
      // done();
      let onTransitionDone = function () {
        done();
        // console.log('leave onTransitionDone');
        el.removeEventListener('transitionend', onTransitionDone, false);
        el.removeEventListener('transitioncancel', onTransitionDone, false);
      };
      // 绑定元素的transition完成事件，在transition完成后立即完成vue的过度动效
      el.addEventListener('transitionend', onTransitionDone, false);
      el.addEventListener('transitioncancel', onTransitionDone, false);
    },
    collapseAfterLeave(el) {
      // console.log('66, collapseAfterLeave');
      el.style.maxHeight = '';
      el.style.overflow = this.oldOverflow;
      el.style.paddingBottom = this.oldPaddingBottom;
      el.style.paddingTop = this.oldPaddingTop;

      this.oldOverflow = this.oldPaddingBottom = this.oldPaddingTop = '';
    },
    creatOrder() {
      let obj = this.calculateList.find(houseItem => houseItem.isChose);
      let query = {
        zipcode: this.zipcodeInput,
        shipdate: Date.now(),
        weight: this.formData.weight,
        uncertainReturn: true,
        uncertainDate: true,
        rzipcode: this.answerType === 'true' ? this.formData.zipcode : '',
        rshipdate: '',
        count: this.formData.quantity,
        name: obj.houseName,
        houseId: obj.houseId,
      };
      let dataObj = {
        zipcodeInput: this.zipcodeInput,
        formShow: this.formShow,
        secondShow: this.secondShow,
        formData: this.formData,
        answerType: this.answerType,
        calculateList: this.calculateList,
        pickup: this.pickup,
        PICKUP_PRICE: this.PICKUP_PRICE,
      };
      this.$store.commit('home/storeData', dataObj);
      this.$store.commit('home/updateSetCacheValue', true);

      if (this.$route.query.change) {
        query.select = 1;
      }
      this.$router.push({
        path: '/send/new',
        query: query,
      });
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ input[type='number'] {
  -moz-appearance: textfield;
}
.limit-package-color {
  color: @app-blue-color;
  margin-left: 10px;
  cursor: pointer;
}
.limit-package-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 30px 50px;
  .content {
    .font-light;
    margin-bottom: 10px;
    font-weight: 300;
    font-size: 16px;
    color: #262626;
    line-height: 19px;
  }
  .click {
    .font-light;
    color: @app-blue-color;
    cursor: pointer;
  }
}
.content {
  .form-content {
    width: 996px;
    height: 485px;
    margin: 0 auto;
    .title {
      .font-regular;
      height: 29px;
      font-size: 24px;
      font-weight: 400;
      color: @app-black-color;
      line-height: 29px;
      margin: 50px 0 36px 0;
    }
    .form {
      .form-item-group {
        display: flex;
        align-items: center;
        gap: 134px;
      }
      .form-label {
        .font-light;
        width: 95%;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        .label-text-right {
          font-size: 12px;
          font-weight: 300;
          color: @app-blue-color;
          line-height: 15px;
        }
      }
      .card-car-content {
        display: flex;
        justify-content: space-between;
        width: 446px;
        height: 88px;
        background: #ffffff;
        border: 1px solid #eeeff0;
        cursor: pointer;
        border-radius: 4px;
        .car-left {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-left: 30px;
          img {
            height: 36px;
          }
          .car-title {
            .font-bold;
            color: @app-black-color;
            font-size: 16px;
          }
        }
        .car-right {
          .font-light;
          text-align: start;
          font-size: 14px;
          font-weight: 300;
          color: @app-black-color;
        }
        .car-desc {
          .font-light;
          background-color: #efeffe;
          color: @app-blue-color;
          font-size: 10px;
          height: 27px;
          line-height: 27px;
          padding: 0 10px;
          border-bottom-left-radius: 15px;
        }
      }
      .active {
        border: 1px solid #6e6def !important;
      }
      .input {
        display: inline-block;
        width: 100%;
        height: 46px;
        line-height: 1.5;
        padding: 4px 7px;
        font-size: 14px;
        border: 1px solid #d8dce2;
        border-radius: 4px;
        color: #262626;
        background-color: #fff;
        background-image: none;
        position: relative;
        cursor: text;
      }
      .error-massage {
        font-family: 'Montserrat-Regular';
        color: #ff7070;
        font-size: 14px;
        padding: 5px 0;
      }
    }
    .btn {
      .font-light;
      width: 220px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #6e6def;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      font-size: 18px;
      font-weight: 300;
      color: #ffffff;
      text-shadow: 0 2px 4px rgba(50, 49, 148, 0.35);
      margin-bottom: 15px;
    }
    .disable-btn {
      background: rgba(110, 109, 239, 0.6);
      box-shadow: 0 2px 4px 0 rgba(50, 49, 148, 0.35);
      border-radius: 6px;
    }
  }
  //动画过渡效果
  .form-box-enter-active,
  .form-box-leave-active {
    transition: height 0.3s ease-in-out, padding 0.3s ease-in-out, max-height 0.3s ease-in-out;
  }

  .price-content {
    width: 996px;
    //max-height: 3000px;
    margin: 0 auto;
    .title-text {
      .font-regular;
      height: 29px;
      font-size: 24px;
      font-weight: 400;
      color: @app-black-color;
      line-height: 29px;
      margin: 0 0 16px 0;
    }
    .title-desc {
      .font-light;
      height: 19px;
      font-size: 16px;
      font-weight: 300;
      color: @app-black-color;
      line-height: 19px;
      button {
        border: none;
        background-color: #ffffff;
        font-size: 16px;
        font-weight: 300;
        color: @app-blue-color;
        cursor: pointer;
      }
    }
    .map-container {
      display: flex;
      flex-direction: column;
      margin-top: 26px;
      //loading样式
      #mapDiv {
        position: relative;
      }
      .loader {
        z-index: 10;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8); /* 半透明白色遮罩 */
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .loader::after {
        content: '';
        border: 5px solid #f3f3f3; /* 浅色边框 */
        border-top: 5px solid #6e6def; /* 蓝色边框 */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      @keyframes spin {
        0% {
          transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
          transform: translate(-50%, -50%) rotate(360deg);
        }
      }
      //地图样式
      .map {
        width: 1026px;
        height: 376px;
        #map {
          width: 100%;
          height: 100%;
        }
      }
      .fee-box {
        margin: 10px 0 27px 0;
        width: 1026px;
        .dropdown-card-close {
          border: 1px solid #eeeff0;
          background-color: #ffffff !important;
        }
        .dropdown-card {
          width: 1026px;
          height: 106px;
          background: #f1f2f8;
          padding: 24px 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          .dropdown-card-left {
            display: flex;
            align-items: center;
            img {
              width: 25px;
              height: 25px;
              margin-right: 30px;
            }
            .left-title {
              .font-light;
              font-size: 18px;
              font-weight: 300;
              color: @app-black-color;
              line-height: 22px;
              white-space: nowrap;
              margin-right: 15px;
            }
            .progress {
              width: 150px;
              white-space: nowrap;
              ::v-deep .ivu-progress-inner {
                background-color: #d8dce2;
              }
            }
          }
          .dropdown-card-right {
            display: flex;
            align-items: center;
            img {
              width: 23px;
              height: 23px;
              margin-left: 20px;
              cursor: pointer;
            }
            .right-title {
              .font-medium;
              font-size: 24px;
              font-weight: 500;
              color: @app-black-color;
              line-height: 29px;
            }
            .right-desc {
              .font-light;
              font-size: 14px;
              font-weight: 300;
              color: @app-black-color;
              line-height: 18px;
            }
          }
        }
        .dropdown-card-disable {
          cursor: not-allowed;
        }
        .dropdown-item-box {
          background: #ffffff;
          border: 1px solid #eeeff0;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding: 0 30px 0 30px;
          .without-border {
            border-bottom: none;
          }
        }
        .dropdown-enter-active {
          transition: opacity 0.5s;
        }
        .dropdown-leave-active {
          transition: opacity 0.1s;
        }

        .dropdown-enter,
        .dropdown-leave-to {
          //transform: translateY(10px);
          opacity: 0;
        }
      }
    }
    .btn {
      .font-light;
      width: 276px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #6e6def;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      font-size: 18px;
      font-weight: 300;
      color: #ffffff;
      text-shadow: 0 2px 4px rgba(50, 49, 148, 0.35);
      margin-bottom: 40px;
    }
  }

  //动画过渡效果
  .map-box-enter-active,
  .map-box-leave-active {
    transition: height 0.3s ease-in-out, padding 0.3s ease-in-out, max-height 0.3s ease-in-out;
  }
}

.package-limit-card {
    padding: 0 27px 27px 7px;
  .title {
    .font-regular;
    font-weight: 400;
    font-size: 14px;
    color: #262626;
  }
  .content {
    .font-light;
    margin-top: 6px;
    font-weight: 300;
    font-size: 12px;
    color: #afb5c6;
    line-height: 15px;
  }
}

/deep/ .ivu-form-item-content {
  margin-left: 0 !important;
}
/deep/ .ivu-form .ivu-form-item-label {
  text-align: left;
}
/deep/ .ivu-modal-header {
  border-bottom: unset;
}
/deep/ .ivu-modal-footer {
  border-top: unset;
}
//.disable-btn {
//  /deep/ .ivu-icon-ios-loading:before {
//    content: '';
//  }
//}
</style>
